import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Flex, Tooltip } from "@mantine/core";
import type { ReactNode } from "react";

interface DefaultBottomBarButtonsProps {
  disabledMessages?: {
    back?: ReactNode;
    next?: ReactNode;
    save?: ReactNode;
  };
  leftSection?: ReactNode;
  onBack?: () => void;
  onNext?: () => void; // temporary fix to prevent publish button from being shown in preview mode
  onSave?: () => void;
  renameMap?: {
    back?: string;
    next?: string;
    save?: string;
  };
}

export const DefaultBottomBarButtons = ({
  disabledMessages = { back: null, next: null, save: null },
  leftSection,
  onBack,
  onNext,
  onSave,
  renameMap = {},
}: DefaultBottomBarButtonsProps) => {
  const { back, next, save } = {
    back: "Back",
    next: "Next",
    save: "Save",
    ...renameMap,
  };

  return (
    <>
      <Flex align="center">
        {onBack && (
          <Tooltip
            disabled={!disabledMessages?.back}
            label={disabledMessages?.back}
          >
            <Button
              c="purple"
              className="border border-uw-purple hover:bg-white mr-2"
              color="white"
              disabled={!!disabledMessages?.back}
              leftSection={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
            >
              {back}
            </Button>
          </Tooltip>
        )}
        {onNext && (
          <Tooltip
            disabled={!disabledMessages?.next}
            label={disabledMessages?.next}
          >
            <Button
              className="mr-3"
              disabled={!!disabledMessages?.next}
              fw={700}
              onClick={onNext}
              rightSection={<FontAwesomeIcon icon={faArrowRight} />}
            >
              {next}
            </Button>
          </Tooltip>
        )}
        {leftSection}
      </Flex>
      {onSave && (
        <Tooltip
          disabled={!disabledMessages?.save}
          label={disabledMessages?.save}
        >
          <Button
            bg="#EFEAFA"
            c="gray.9"
            disabled={!!disabledMessages?.save}
            fw={700}
            onClick={onSave}
          >
            {save}
          </Button>
        </Tooltip>
      )}
    </>
  );
};
